module.exports = __webpack_public_path__ + "img/alpha.87884d84.png";